<template>
  <div class="the-carousel">
    <vue-slick-carousel
      class="the-carousel__slider"
      ref="carousel"
      v-bind="carouselOptions"
    >
      <slot />
      <template slot="prevArrow">
        <div class="the-carousel__slider__arrow prev" />
      </template>
      <template slot="nextArrow">
        <div class="the-carousel__slider__arrow next" />
      </template>
    </vue-slick-carousel>
  </div>
</template>

<script>
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';
import VueSlickCarousel from 'vue-slick-carousel';

export default {
  components: { VueSlickCarousel },
  mounted() {
    this.goTo();
  },
  methods: {
    /**
     * Скролл к установленному слайду
     */
    goTo() {
      this.$refs.carousel.goTo(this.selectedSlide);
    },
  },
  props: {
    /**
     * @description Настройки карусели.
     * @type {any}
     */
    carouselOptions: {
      type: Object,
      default: () => ({
        arrows: true,
        draggable: false,
        infinite: true,
        slidesToShow: 6,
        speed: 500,
        responsive: [
          {
            breakpoint: 1700,
            settings: {
              slidesToShow: 5,
            },
          },
          {
            breakpoint: 1500,
            settings: {
              slidesToShow: 4,
            },
          },
          {
            breakpoint: 1120,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 860,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      }),
    },
    selectedSlide: { type: Number, default: null },
  },
};
</script>

<style scoped lang="scss">
.the-carousel {
  &__slider {
    transition: 2s ease-in-out;
    position: relative;
    margin: 0 -6px;
    padding: 20px 0 45px 0;
    &::v-deep .slick-slide {
      padding: 0 3px;
    }
    &__arrow {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      bottom: 10px;
      top: inherit;
      width: 26px;
      max-width: 26px;
      height: 26px;
      max-height: 26px;
      border: 1px solid #0489e0;
      border-radius: 50%;
      background-repeat: no-repeat;
      background-position: center;
      transform: none;
      &.slick-next:before,
      &.slick-prev:before {
        content: none;
      }
      &:hover {
        background-repeat: no-repeat;
        background-position: center;
      }
      &.prev {
        right: 50px;
        left: inherit;
        background-image: url("@/assets/img/arrow/arrow-blue.svg");
      }
      &.next {
        right: 0;
        background-image: url("@/assets/img/arrow/arrow-blue.svg");
        transform: rotate(180deg);
      }
    }
  }
}
</style>
